import { Email, Phone } from "@mui/icons-material";
import {
  Avatar,
  Button,
  Card,
  Divider,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { deepPurple } from "@mui/material/colors";
import React from "react";

const VendorDispalyCard = ({ vendor, buttonTitle, buttonOnClick }) => {
  return (
    <Card
    component={Paper}
      sx={{
        mb: 3,
        borderRadius: 2,
        boxShadow: 3,
        // maxWidth: 480,
        mx: "auto",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ p: 2 }}
      >
        <Stack direction="row" alignItems="center" spacing={4}>
          <Stack direction={"row"} gap={2} alignItems="center">
            <Avatar sx={{ bgcolor: deepPurple[500] }}>
              {vendor?.name?.slice(0, 1).toUpperCase()}
            </Avatar>
            <Typography variant="subtitle1">{vendor.name}</Typography>
          </Stack>
          <Divider orientation="vertical" flexItem />
          <Stack direction={"row"} gap={1}>
            <Phone />
            <Typography variant="body2" color="text.secondary">
              +{vendor.phoneNumber}
            </Typography>
          </Stack>
          <Divider orientation="vertical" flexItem />
          <Stack direction={"row"} gap={1}>
            <Email />
            <Typography variant="body2" color="text.secondary">
              {vendor.email}
            </Typography>
          </Stack>
        </Stack>
        {
          <IconButton
            size="small"
            variant="outlined"
            color="error"
            onClick={() => {
              buttonOnClick?.();
           }}
          >
            {buttonTitle}
          </IconButton>
        }
      </Stack>
    </Card>
  );
};

export default VendorDispalyCard;
